module.exports = __webpack_public_path__ + "static/img/template3.aa2bc151.png";